import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatAutocompleteModule, } from "@angular/material/autocomplete";
import { MatBadgeModule} from "@angular/material/badge";
import { MatButtonModule} from "@angular/material/button";
import { MatButtonToggleModule} from "@angular/material/button-toggle";
import { MatCardModule} from "@angular/material/card";
import { MatCheckboxModule} from "@angular/material/checkbox";
import { MatChipsModule} from "@angular/material/chips";
import { MatDatepickerModule} from "@angular/material/datepicker";
import { MatDialogModule} from "@angular/material/dialog";
import { MatExpansionModule} from "@angular/material/expansion";
import { MatFormFieldModule} from "@angular/material/form-field";
import { MatIconModule} from "@angular/material/icon";
import { MatInputModule} from "@angular/material/input";
import { MatListModule} from "@angular/material/list";
import { MatMenuModule} from "@angular/material/menu";
import { MatNativeDateModule} from "@angular/material/core";
import { MatPaginatorModule} from "@angular/material/paginator";
import { MatProgressBarModule} from "@angular/material/progress-bar";
import { MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { MatRadioModule} from "@angular/material/radio";
import { MatSelectModule} from "@angular/material/select";
import { MatSidenavModule} from "@angular/material/sidenav";
import { MatSliderModule} from "@angular/material/slider";
import { MatSlideToggleModule} from "@angular/material/slide-toggle";
import { MatSnackBarModule} from "@angular/material/snack-bar";
import { MatSortModule} from "@angular/material/sort";
import { MatStepperModule} from "@angular/material/stepper";
import { MatTableModule} from "@angular/material/table";
import { MatTabsModule} from "@angular/material/tabs";
import { MatToolbarModule} from "@angular/material/toolbar";
import { MatTooltipModule} from "@angular/material/tooltip";
import { MatTreeModule} from "@angular/material/tree";
import { AngularSplitModule } from 'angular-split';
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxPaginationModule } from 'ngx-pagination'
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CloseAutocompleteOnScrollDirective } from '../directives/close-autocomplete-on-scroll.directive';

@NgModule({
  declarations: [CloseAutocompleteOnScrollDirective],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    AngularSplitModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    NgxFileDropModule,
    NgxPaginationModule,
    DragDropModule
  ],
  exports: [
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    AngularSplitModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    InfiniteScrollModule,
    NgxFileDropModule,
    NgxPaginationModule,
    DragDropModule,
    CloseAutocompleteOnScrollDirective
  ]
})
export class GlobalModulesModule { }
